import { Component, OnInit, Input, ElementRef, NgZone, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { HyphenatePipe } from '../../pipes/hyphenate';
import { UrlTree, Router, NavigationExtras } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { FocusMonitor } from '@angular/cdk/a11y';


@Component({
  selector: 'dls-page-section-container',
  templateUrl: './page-section-container.component.html'
})
export class PageSectionContainerComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('headLineReference') private headLineRef: ElementRef<HTMLElement>;

  public sectionFragmentID: string;
  public isMouseOver: boolean;
  public isFocus: boolean;

  @Input() headline: string;

  constructor(
    private _hyphenate: HyphenatePipe,
    private _clipboard: Clipboard,
    private _router: Router,
    private _focusMonitor: FocusMonitor,
    private _ngZone: NgZone
  ) {
    this.sectionFragmentID = null;
    this.isMouseOver = false;
    this.isFocus = false;
  }

  ngOnInit(): void {
    if (this.headline) {

      // Create fragment with Page Section headline and Section Title
      this.sectionFragmentID = this._hyphenate
        .transform(`${this.headline}`)
        .toLocaleLowerCase();
    }
  }

  ngAfterViewInit(): void {
    if (this.headline) {
      this._focusMonitor
        .monitor(this.headLineRef.nativeElement, true)
        .subscribe(
          origin => {
            // To execute focus event with in Angular
            this._ngZone.run(() => {
              this.isFocus = origin !== null;
            });
          });
    }
  }

  ngOnDestroy(): void {
    if (this.headline) {
      this._focusMonitor.stopMonitoring(this.headLineRef.nativeElement);
    }
  }

  // Copy the current url with page section fragment
  public copyLink(): void {
    const currentUrlTree: UrlTree = this._router.createUrlTree([], <NavigationExtras>{ fragment: this.sectionFragmentID });

    // Sets section fragment to the URL
    this._router.navigateByUrl(currentUrlTree);

    // Copy the current URL with fragment to clipboard
    this._clipboard.copy(`${window.location.origin}${window.location.pathname}#${this.sectionFragmentID}`);
  }
}
